import { contentfulImageSchema } from '@ecomm/contentful-components'
import { z } from '@simplisafe/ewok'

export const expertSectionAssetSchema = z.object({
  expertSectionAsset: contentfulImageSchema
})
